import { Component, EventEmitter, signal, computed, effect } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { Site } from '../../bo/site';
import { WorkflowModele } from '../../bo/workflowModele';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { WorkflowModeleModaleComponent } from '../workflow-modele-modale/workflow-modele-modale.component';

@Component({
  selector: 'app-workflow-modele',
  templateUrl: './workflow-modele.component.html',
  styleUrls: ['./workflow-modele.component.scss'],
  standalone: false
})
export class WorkflowModeleComponent {
  readonly currentSiteId = signal<number | undefined>(undefined);
  modale: BsModalRef;
  readonly tabWorkflowModeles = signal<WorkflowModele[]>([]);
  readonly proprietesAfficheesWorkflowModeles = signal<ProprieteAffichee[]>(new WorkflowModele().getProprietesAffichees());
  readonly erreurRecuperation = signal(false);
  readonly listeModifiee = new EventEmitter<any>();

  constructor(private readonly modalService: BsModalService, private readonly http: HttpService, private readonly utilService: UtilisateurService, private readonly fonctionsService: FonctionsService,
    private readonly translate: TranslateService) {
    this.modalService.onHide.observers = [];
    this.modalService.onHide.subscribe((val: any) => {
      if (this.modale && this.modale.content && this.modale.content.workflowModele.workflowModeleId != -1 && val != "esc") {
        var workflowModeleId = this.tabWorkflowModeles().findIndex(p => p.workflowModeleId == this.modale.content.workflowModele.workflowModeleId);
        if (this.modale.content.successDelete) { //Suppr
          this.tabWorkflowModeles.update(list => {
            const updated = [...list];
            updated.splice(workflowModeleId, 1);
            return updated;
          });
        } else if (workflowModeleId != -1) { // Modif
          this.tabWorkflowModeles.update(list => {
            const updated = [...list];
            Object.assign(updated[workflowModeleId], this.modale.content.workflowModele);
            return updated;
          });
        } else {
          let index = this.lastindexOf(this.modale.content.workflowModele.siteId);
          this.tabWorkflowModeles.update(list => {
            const updated = [...list];
            updated.splice(index, 0, this.modale.content.workflowModele);
            if (this.modale.content.workflowModele.workflowModeleParentId) { //Supression du wf parent dans la liste
              var id = updated.findIndex(p => p.workflowModeleId == this.modale.content.workflowModele.workflowModeleParentId);
              updated.splice(id, 1);
            }
            return updated;
          });
        }
        this.listeModifiee.emit(true);
        this.modale = null;
      }
    });

    effect(() => {
      const site = this.utilService.currentSite();
      if (!site || site.siteId === this.currentSiteId()) return;
      this.currentSiteId.set(site.siteId);
      this.refreshData();
    });

    // Initialize on construction
    const initialSite = this.utilService.currentSite();
    if (initialSite && this.isValidSiteId(initialSite.siteId)) {
      this.currentSiteId.set(initialSite.siteId);
      this.refreshData();
    }
  }

  refreshData() {
    if (!this.isValidSiteId(this.currentSiteId())) {
      return;
    }
    this.erreurRecuperation.set(false);
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    this.http.get<WorkflowModele[]>('Sites/' + this.currentSiteId() + '/WorkflowModeles').subscribe(resultat => {
      this.tabWorkflowModeles.set(resultat);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    });
  }

  ouvrirModaleAjout() {
    var initialState = {
      estMiseJour: false
    };
    this.modale = this.modalService.show(WorkflowModeleModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState, class: "modal-lg" });
  }

  ouvrirModale(w: WorkflowModele) {
    this.fonctionsService.loading_screen(true);
    this.http.get<WorkflowModele>('WorkflowsModeles/' + w.workflowModeleId).subscribe(workflowModele => {
      if (!workflowModele.workflowEtapeModeles) {
        workflowModele.workflowEtapeModeles = [];
      }
      var initialState = {
        workflowModele: workflowModele,
        estMiseJour: true
      };
      this.fonctionsService.loading_screen(false);
      this.modale = this.modalService.show(WorkflowModeleModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState, class: "modal-lg" });
    }, () => {
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
      this.fonctionsService.loading_screen(false);
    });
  }

  lastindexOf(siteId: number) {
    let index = 0;
    const list = this.tabWorkflowModeles();
    for (let i = 0; i < list.length; i++) {
      if (list[i].siteId == siteId)
        index = i;
    }
    return index + 1;
  }

  private isValidSiteId(siteId: number): boolean {
    return Number.isFinite(siteId);
  }
}
